import React from "react";
import styled from "styled-components";

export default styled.p`
    text-align: center;
    color: #515151;
    font-size: 18px;
    line-height: 21px;
    width: 286px;
    margin: 0 auto;
`;